<template>
  <l-geo-json
    :visible="mapRegionsWithGeoData && $store.state.mode === 'manualupdate'"
    :geojson="mapRegionsWithGeoData"
    :options="mapRegionsOptionsOtaChange"
  ></l-geo-json>
</template>
<script lang="js">
import Vue from 'vue';
import {LGeoJson} from 'vue2-leaflet';
import {
  onEachFeature,
  mouseOverRegion,
  mouseOutRegion,
  redrawMap,
  generateTooltip,
  calculateStyle,
} from './methods.js'

export default Vue.extend({
  name: 'nmouc-map-manual-update',
  props: {
    mapRegionsWithGeoData: {
      type: Object,
      required: true,
    }
  },
  components: {
    LGeoJson,
  },
  data() {
    return {
      mapRegionsOptionsOtaChange: {
        style: {
          pane: 'mapRegionsPane'
        },
        onEachFeature: this.onEachFeature
      },
    };
  },
  watch: {
    '$store.state.manualUpdate.step': function() {
      this.redrawMap();
    },
    '$store.state.manualUpdate.selectedRegions': function () {
      this.redrawMap();
    },
    '$store.state.manualUpdate.completeMapSelected': function () {
      this.redrawMap();
    }
  },
  methods: {
    onEachFeature,
    mouseOverRegion,
    mouseOutRegion,
    redrawMap,
    generateTooltip,
    calculateStyle,
    clickedFeature(e) {
      if (this.isRegionClickAllowed() && this.isClickedRegionOutdated(e.target.feature.properties.mapInfos)) {
        this.$store.commit('toggleManualUpdateSelectedRegion', e.target.feature.properties.mapInfos)
      }
    },
    isRegionClickAllowed() {
      return this.$store.state.manualUpdate.step === 1
        && this.$store.state.manualUpdate.completeMapSelected === false;
    },
    isClickedRegionOutdated(region) {
      return !region.upToDate
    }
  }
});
</script>
